(() => {
  'use strict';
  const formatOrder = {bags: 0, packs: 1, boxes: 2};
  const seriesOrder = {crow: 0, adventure: 1, counter: 2, nerdrotic: 3, other: 4};
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const grid = root.querySelector('[data-warehouse-grid]');
    const status = root.querySelector('[data-warehouse-status]');
    const warning = root.querySelector('[data-warehouse-warning]');
    const search = root.querySelector('[data-warehouse-search]');
    const sorting = root.querySelector('[data-warehouse-sort]');
    const stock = root.querySelector('[data-warehouse-stock]');
    const roast = root.querySelector('[data-warehouse-roast]');
    const extraFilters = root.querySelector('[data-warehouse-extra-filters]');
    const filterSummary = root.querySelector('[data-warehouse-filter-summary]');
    const desktopFilters = window.matchMedia('(min-width: 750px)');
    const shippingCallout = root.querySelector('.ggw-shipping-callout');
    const controls = root.querySelector('[data-warehouse-controls]');
    function syncFilterLayout() {
      extraFilters.open = desktopFilters.matches;
      if (desktopFilters.matches) controls.before(shippingCallout);
      else controls.parentElement.appendChild(shippingCallout);
    }
    syncFilterLayout();
    desktopFilters.addEventListener('change', syncFilterLayout);
    extraFilters.addEventListener('toggle', () => { if (desktopFilters.matches && !extraFilters.open) extraFilters.open = true; });
    const roastLabels = new Set();
    const sources = [...grid.querySelectorAll('[data-warehouse-source]')];
    const cards = new Map();
    let format = 'all', series = 'all', loading = false, failed = false;
    const urlFormat = new URL(location.href).searchParams.get('warehouse_format');
    if (['bags','packs','boxes','samples'].includes(urlFormat)) format = urlFormat;
    const urlSeries = new URL(location.href).searchParams.get('warehouse_series');
    if (['crow','adventure','counter','nerdrotic'].includes(urlSeries)) {
      series = urlSeries;
      if (['boxes','samples'].includes(format)) format = 'all';
    }
    function collect(scope) {
      scope.querySelectorAll('[data-warehouse-card]').forEach(card => {
        if (cards.has(card.dataset.id)) return;
        card.dataset.sequence = String(cards.size);
        const roastLabel = card.querySelector('.ggx-card-facts__roast > span:first-child,.gg-15packs__roast > span:first-child')?.textContent.trim() || '';
        card.dataset.roast = roastLabel;
        if (roastLabel && !roastLabels.has(roastLabel)) { const option = document.createElement('option');option.value=roastLabel;option.textContent=roastLabel;roast.appendChild(option);roastLabels.add(roastLabel); }
        card.dataset.search = (card.dataset.search + ' ' + card.textContent).toLowerCase();
        cards.set(card.dataset.id, card);
        grid.appendChild(card);
      });
    }
    sources.forEach(collect);
    function featured(a,b) {
      const f = formatOrder[a.dataset.format] - formatOrder[b.dataset.format];
      if (f) return f;
      if (a.dataset.format === 'bags') {
        const s = seriesOrder[a.dataset.series] - seriesOrder[b.dataset.series];
        if (s) return s;
      }
      return Number(a.dataset.rank)-Number(b.dataset.rank) || Number(a.dataset.sequence)-Number(b.dataset.sequence);
    }
    function update() {
      const term = search.value.trim().toLowerCase();
      let count = 0;
      const ordered = [...cards.values()].sort((a,b) => {
        if (sorting.value === 'title') return a.dataset.title.localeCompare(b.dataset.title);
        if (sorting.value.startsWith('price-')) {
          // Configurable boxes have no comparable fixed price; always place them last.
          if ((a.dataset.format === 'boxes') !== (b.dataset.format === 'boxes')) return a.dataset.format === 'boxes' ? 1 : -1;
          return (Number(a.dataset.price)-Number(b.dataset.price)) * (sorting.value === 'price-asc' ? 1 : -1) || featured(a,b);
        }
        return featured(a,b);
      });
      ordered.forEach(card => {
        card.hidden = !((format === 'all' || card.dataset.format === format || (format === 'samples' && card.dataset.format === 'boxes' && ['7702261989626','7703268688122'].includes(card.dataset.id))) && (series === 'all' || card.dataset.series === series) && (!roast.value || card.dataset.roast === roast.value) && (!term || card.dataset.search.includes(term)) && (!stock.checked || card.dataset.available === 'true'));
        if (!card.hidden) count++;
        grid.appendChild(card);
      });
      root.querySelectorAll('[data-format-choice]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.formatChoice === format)));
      root.querySelectorAll('[data-series-choice]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.seriesChoice === series)));
      root.querySelector('[data-warehouse-empty]').hidden = count > 0 || loading;
      status.textContent = `${count} coffee ${count === 1 ? 'option' : 'options'}${loading ? ' loaded; checking remaining coffees…' : failed ? ' loaded; catalog incomplete' : ''}`;
      warning.hidden = !failed;
      const activeFilters = [];
      if (series !== 'all') activeFilters.push(root.querySelector(`[data-series-choice="${series}"]`).textContent.trim());
      if (term) activeFilters.push('Search');
      if (roast.value) activeFilters.push(roast.value);
      if (stock.checked) activeFilters.push('In stock');
      if (sorting.value !== 'featured') activeFilters.push(sorting.selectedOptions[0].textContent.trim());
      filterSummary.textContent = activeFilters.length ? '· ' + activeFilters.join(' · ') : '';
    }
    async function loadSources() {
      if (loading) return;
      loading = true; failed = false; root.dataset.loading = 'true'; update();
      try {
        for (const source of sources) {
          let next = source.querySelector('[data-warehouse-next]')?.href;
          if (Number(source.dataset.sourcePage) > 1) next = source.dataset.sourceFirst;
          const visited = new Set();
          while (next) {
            const url = new URL(next, location.href);
            if (url.origin !== location.origin || url.searchParams.get('view') !== 'gg-warehouse-feed' || visited.has(url.href) || visited.size >= 100) throw new Error('Invalid or oversized catalog pagination');
            visited.add(url.href);
            const controller = new AbortController();
            const timer = setTimeout(() => controller.abort(), 15000);
            let response;
            try { response = await fetch(url.href, {credentials:'same-origin', signal:controller.signal}); } finally { clearTimeout(timer); }
            if (!response.ok) throw new Error('Catalog request failed');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const page = html.querySelector(`[data-warehouse-source="${source.dataset.warehouseSource}"]`);
            if (!page) throw new Error('Catalog response missing');
            collect(page); update();
            next = page.querySelector('[data-warehouse-next]')?.getAttribute('href');
          }
          source.querySelectorAll('[data-warehouse-next],[data-warehouse-first]').forEach(link => link.remove());
        }
      } catch (error) { failed = true; }
      loading = false; root.dataset.loading = 'false'; update();
    }
    root.querySelector('[data-warehouse-controls]').hidden = false;
    root.addEventListener('click', event => {
      const choice = event.target.closest('[data-format-choice],[data-series-choice]');
      if (choice) {
        if (choice.dataset.formatChoice) { format = choice.dataset.formatChoice; if (['boxes','samples'].includes(format)) { series = 'all'; roast.value = ''; } }
        if (choice.dataset.seriesChoice) { series = choice.dataset.seriesChoice; if (series !== 'all' && ['boxes','samples'].includes(format)) format = 'all'; }
        update();
      }
      if (event.target.closest('[data-warehouse-reset]')) { format='all';series='all';search.value='';roast.value='';stock.checked=false;sorting.value='featured';update(); }
      if (event.target.closest('[data-warehouse-retry]')) loadSources();
    });
    search.addEventListener('input', update); sorting.addEventListener('change', update); stock.addEventListener('change', update);roast.addEventListener('change', update);
    update(); loadSources();
  }
  function boot(scope=document) { scope.querySelectorAll('[data-warehouse-unified]').forEach(initialize); }
  boot(); document.addEventListener('shopify:section:load', event=>boot(event.target));
})();

